import HomePage from "@/views/HomePage.vue";
import FamilyOffice from "@/views/FamilyOffice.vue";
import FortyTwo from "@/views/FortyTwo.vue";
import Quant from "@/views/Quant.vue";
import About from "@/views/About.vue";
import Terms from "@/views/Terms.vue";
import Contact from "@/views/Contact.vue";
import Privacy from "@/views/Privacy.vue";

import { createRouter, createWebHistory } from "vue-router";
import { h, resolveComponent } from "vue";

const routes = [
  {
    path: "/",
    component: {
      render() {
        return h(resolveComponent("router-view"));
      },
    },
    meta: {
      title: "42Monks Capital",
      metaTags: [
        {
          name: "description",
          content: "42Monks Capital",
        },
        {
          property: "og:description",
          content: "42Monks Capital",
        },
      ],
    },
    children: [
      {
        path: "",
        name: "42Monks",
        component: HomePage,
        meta: {
          title: "42Monks Capital",
          metaTags: [
            {
              name: "42Monks Capital",
              content: "42Monks Office. Quantitative Trading, Generational Wealth Management.",
            },
            {
              property: "og:42Monks Capital",
              content: "42Monks Office. Quantitative Trading, Generational Wealth Management.",
            },
          ],
        },
      },
      {
        path: "/office",
        name: "FamilyOffice",
        component: FamilyOffice,
        meta: {
          title: "Family Office",
          metaTags: [
            {
              name: "Family Office",
              content: "Family Office.",
            },
            {
              property: "og:Family Office",
              content: "Family Office.",
            },
          ],
        },
      },
      {
        path: "/fund",
        name: "FortyTwo",
        component: FortyTwo,
        meta: {
          title: "Wealth Management",
          metaTags: [
            {
              name: "Wealth Management",
              content: "42Monks Capital. Quantitative Trading, Generational Wealth Management.",
            },
            {
              property: "og:Wealth Management",
              content: "42Monks Capital. Quantitative Trading, Generational Wealth Management.",
            },
          ],
        },
      },
      {
        path: "/about",
        name: "About",
        component: About,
        meta: {
          title: "About",
          metaTags: [
            {
              name: "About",
              content: "42Monks Capital. Quantitative Trading, Generational Wealth Management.",
            },
            {
              property: "og:About",
              content: "42Monks Capital. Quantitative Trading, Generational Wealth Management.",
            },
          ],
        },
      },
      {
        path: "/contact",
        name: "Contact",
        component: Contact,
        meta: {
          title: "Contact",
          metaTags: [
            {
              name: "Contact",
              content: "42Monks Capital. Quantitative Trading, Generational Wealth Management.",
            },
            {
              property: "og:Contact",
              content: "42Monks Capital. Quantitative Trading, Generational Wealth Management.",
            },
          ],
        },
      },
      {
        path: "/quant",
        name: "Quant",
        component: Quant,
        meta: {
          title: "Quantitative Trading",
          metaTags: [
            {
              name: "Quantitative Trading",
              content: "42Monks Capital Quantitative Trading.",
            },
            {
              property: "og:Quantitative Trading",
              content: "42Monks Capital Quantitative Trading.",
            },
          ],
        },
      },
      {
        path: "/terms",
        name: "Terms",
        component: Terms,
        meta: {
          title: "Terms & Conditions",
          metaTags: [
            {
              name: "42Monks Capital Terms & Conditions",
              content:
                "42Monks Capital Terms & Conditions.",
            },
            {
              property: "og:42Monks Capital Terms & Conditions",
              content:
                "42Monks Capital Terms & Conditions.",
            },
          ],
        },
      },
      {
        path: "/privacy",
        name: "Privacy",
        component: Privacy,
        meta: {
          title: "Privacy Policy",
          metaTags: [
            {
              name: "42Monks Capital Privacy Policy",
              content: "42Monks Capital Privacy Policy.",
            },
            {
              property: "og:42Monks Capital Privacy Policy",
              content: "42Monks Capital Privacy Policy.",
            },
          ],
        },
      }
    ],
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return { left: 0, top: 0 };
  },
});

export default router;
